/* AAshop matching products. Native primary-product submission is independent. */
(() => {
  if (customElements.get('aashop-set-purchase')) return;
  // AAshop 15/10-2026: engelsk visning på /en-eu og /en-se
  const AA_EN=!/^da\b/i.test(document.documentElement.lang||'da');
  const L=(da,en)=>AA_EN?en:da;
  const states = new WeakMap();
  let noticeTimer;
  class AASetPurchase extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      queueMicrotask(() => this.connect());
    }
    disconnectedCallback() { this.abort?.abort(); }
    connect() {
      if (!this.isConnected) return;
      this.form = this.closest('.product-info')?.querySelector('product-form form');
      if (!this.form) return;
      try { this.products = JSON.parse(this.querySelector('[data-set-products]').textContent); }
      catch (_) { return; }
      this.select = this.querySelector('[data-set-variant]');
      this.button = this.querySelector('[data-set-add]');
      if (!this.select || !this.button) return;
      this.group = states.get(this.form);
      if (!this.group) { this.group={cards:new Map(),tail:Promise.resolve(),pending:0}; states.set(this.form,this.group); }
      this.state = this.group.cards.get(this.dataset.matchingId);
      if (!this.state || this.state.product !== this.dataset.productId) {
        this.state = { product:this.dataset.productId, matching:this.dataset.matchingId, selected:'', busy:false, uncertain:false };
        this.group.cards.set(this.dataset.matchingId, this.state);
      }
      const selected = this.products.matching.find(v => String(v.id) === this.state.selected && v.available);
      const single = this.dataset.singleVariant === 'true' && this.products.matching.find(v=>v.available);
      this.select.value = selected ? String(selected.id) : single ? String(single.id) : '';
      this.state.selected = this.select.value;
      this.querySelector('[data-set-control]').hidden = false;
      this.querySelector('[data-set-fallback]').hidden = true;
      this.select.addEventListener('change', () => {
        this.state.selected = this.select.value;
        this.message('');
        this.update();
      }, {signal:this.abort.signal});
      this.button.addEventListener('click', () => this.add(), {signal:this.abort.signal});
      this.form.addEventListener('submit', event => {
        if (this.form.checkValidity() && this.group.lastSubmit !== event) {
          this.group.lastSubmit=event;
          this.group.nativeCount=(this.group.nativeCount || 0)+1;
          if (!this.group.nativePending) this.group.nativePending = new Promise(resolve=>{this.group.finishNative=resolve;});
        }
      }, {capture:true,signal:this.abort.signal});
      for (const name of ['variant:add','cart:error']) this.form.addEventListener(name,event=>{
        if (this.group.lastTerminal===event) return;
        this.group.lastTerminal=event;
        this.group.nativeCount=Math.max(0,(this.group.nativeCount || 0)-1);
        if (!this.group.nativeCount) {this.group.finishNative?.(); this.group.nativePending=null; this.group.nativeUncertain=false;}
      }, {signal:this.abort.signal});
      this.update();
    }
    current() { return Array.from(this.form?.closest('.product-info')?.querySelectorAll('aashop-set-purchase') || []).find(el=>el.dataset.matchingId === this.dataset.matchingId) || this; }
    money(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'da-DK', {
        style:'currency', currency:this.dataset.currency || window.Shopify?.currency?.active || 'DKK'
      }).format(cents / 100);
    }
    matchingVariant() { return this.products.matching.find(v => String(v.id) === this.state.selected && v.available); }
    update() {
      const matching = this.matchingVariant();
      this.select.disabled = this.state.busy;
      this.button.disabled = this.state.busy || !matching;
      this.button.textContent = this.state.busy ? L('Tilføjer...','Adding...') : this.products.matching.some(v=>v.available) ? L('Læg i kurv','Add to cart') : L('Udsolgt','Sold out');
      this.button.toggleAttribute('aria-busy', this.state.busy);
      if (this.group.pending && this.group.nativeButtons) this.lockNative();
      this.querySelector('[data-set-price]').textContent = this.money(matching?.price ?? Math.min(...this.products.matching.map(v=>v.price)));
    }
    lockNative() {
      this.group.nativeButtons ||= [];
      for (const button of Array.from(this.form.elements).filter(el=>el.type==='submit')) {
        if (!this.group.nativeButtons.some(entry=>entry.button===button)) this.group.nativeButtons.push({button,disabled:button.disabled});
        button.disabled=true;
      }
    }
    message(text, error=false, cartLink=false) {
      const box = this.current().querySelector('[data-set-message]');
      box.hidden = !text;
      box.toggleAttribute('data-error', error);
      box.replaceChildren(document.createTextNode(text));
      if (cartLink) {
        const link = document.createElement('a');
        link.href = (window.Shopify?.routes?.root || '/') + 'cart';
        link.textContent = L('Se kurven','View cart');
        box.append(link);
      }
    }
    notify(variant) {
      let notice = document.getElementById('aa-set-notice');
      if (!notice) {
        notice = document.createElement('div');
        notice.id = 'aa-set-notice';
        notice.className = 'aa-set-notice';
        notice.setAttribute('role','status');
        notice.setAttribute('aria-live','polite');
        notice.innerHTML = '<span class="aa-set-notice__check" aria-hidden="true">✓</span><div><strong>' + L('Lagt i kurven','Added to cart') + '</strong><span data-notice-product></span><br><a>' + L('Se kurven','View cart') + '</a></div><button type="button" aria-label="' + L('Luk kvittering','Close confirmation') + '">×</button>';
        notice.querySelector('button').addEventListener('click',()=>{notice.hidden=true;});
        notice.querySelector('a').addEventListener('click',event=>{
          const drawer=document.querySelector('cart-drawer');
          if (drawer?.show) {event.preventDefault();notice.hidden=true;drawer.show();}
        });
        document.body.append(notice);
      }
      const title = this.querySelector('.aa-set__title').textContent.trim();
      notice.querySelector('[data-notice-product]').textContent = title + (variant.title === 'Default Title' ? '' : `, ${variant.title}`);
      notice.querySelector('a').href = (window.Shopify?.routes?.root || '/') + 'cart';
      const anchor = Array.from(document.querySelectorAll('header [aria-controls="cart-drawer"],.shopify-section--header [href$="/cart"]')).find(el=>el.getBoundingClientRect().width>0);
      const rect = anchor?.getBoundingClientRect();
      notice.style.top = `${rect && rect.bottom>0 ? Math.min(rect.bottom+16,180) : 20}px`;
      notice.style.right = `${rect ? Math.max(12,innerWidth-rect.right) : 20}px`;
      notice.hidden = false;
      clearTimeout(noticeTimer);
      noticeTimer = setTimeout(()=>{notice.hidden=true;},6500);
    }
    async json(url, options={}) {
      const response = await fetch(url, {...options, signal:AbortSignal.timeout(20000)});
      let body;
      try { body=await response.json(); } catch (_) { throw new Error('invalid-response'); }
      return {response, body};
    }
    async add() {
      if (this.state.busy) return;
      const matching = this.matchingVariant();
      if (!matching) { this.select.focus(); return; }
      this.message('');
      this.state.busy=true;
      this.update();
      const reconcileOnly=!this.group.pending && this.group.uncertain;
      const previous=this.group.tail;
      let release;
      this.group.tail=new Promise(resolve=>{release=resolve;});
      this.group.pending++;
      await previous;
      const root=window.Shopify?.routes?.root || '/';
      const sections=[];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections',{bubbles:true,detail:{sections}}));
      const payload = new FormData();
      payload.set('items[0][id]',String(matching.id));
      payload.set('items[0][quantity]','1');
      payload.set('sections',sections.join(','));
      payload.set('sections_url',root+'cart');
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start',{bubbles:true}));
      let before=null, posted=false;
      try {
        if (this.group.nativePending) {
          let timer;
          try { await Promise.race([this.group.nativePending,new Promise((_,reject)=>{timer=setTimeout(()=>reject(new Error('native-cart-timeout')),20000);})]); }
          catch (_) { this.group.nativeUncertain=true; this.group.finishNative?.(); this.group.nativePending=null; }
          finally { clearTimeout(timer); }
        }
        if (this.group.nativeUncertain) {
          this.message(L('Kurven svarer langsomt. Kontrollér kurven, før du tilføjer flere varer.','The cart is responding slowly. Check your cart before adding more items.'),true,true);
          return;
        }
        // Queue distinct accessory clicks and block native buttons only while that queue runs.
        this.lockNative();
        const check=await this.json(`${root}cart.js`);
        if (!check.response.ok) throw new Error('cart-unavailable');
        before=check.body;
        if (this.state.uncertain || this.group.uncertain) {
          this.state.uncertain=false;
          if (reconcileOnly) this.group.uncertain=false;
          this.message(L('Kontrollér kurven, før du tilføjer varen igen.','Check your cart before adding the item again.'),true,true);
          return;
        }
        posted=true;
        const result=await this.json(`${root}cart/add.js`,{method:'POST',body:payload,headers:{'X-Requested-With':'XMLHttpRequest'}});
        const after=await this.json(`${root}cart.js`);
        if (!after.response.ok) throw new Error('cart-unavailable-after-add');
        const cart=after.body;
        if (!result.response.ok) {
          const changed=JSON.stringify(before.items.map(i=>[i.key,i.quantity])) !== JSON.stringify(cart.items.map(i=>[i.key,i.quantity]));
          this.state.uncertain=changed;
          if (changed) this.group.uncertain=true;
          this.message((result.body.description || L('Varen kunne ikke tilføjes.','The item could not be added.')) + (changed ? L(' Kurven er ændret. Kontrollér indholdet før et nyt forsøg.',' Your cart has changed. Check it before trying again.') : L(' Vælg en anden størrelse og prøv igen.',' Choose another size and try again.')),true,changed);
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          return;
        }
        cart.sections=result.body.sections;
        if (sections.some(id=>typeof cart.sections?.[id]!=='string' || !cart.sections[id].trim())) {
          const refreshed=await this.json(`${root}?sections=${encodeURIComponent(sections.join(','))}`);
          if (refreshed.response.ok) cart.sections=refreshed.body;
        }
        this.current().dispatchEvent(new CustomEvent('variant:add',{bubbles:true,detail:{items:result.body.items || [result.body],cart}}));
        // Update the native drawer and counter without opening it over the primary product.
        if (sections.every(id=>typeof cart.sections?.[id]==='string' && cart.sections[id].trim())) {
          document.documentElement.dispatchEvent(new CustomEvent('cart:change',{bubbles:true,detail:{baseEvent:'aa-set:add',cart}}));
        } else document.dispatchEvent(new CustomEvent('cart:refresh'));
        this.current().notify(matching);
      } catch (_) {
        let reconciled=false;
        if (posted) {
          this.state.uncertain=true;
          this.group.uncertain=true;
          try {
            const check=await this.json(`${root}cart.js`);
            if (check.response.ok) {
              reconciled=true;
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              const changed=before && JSON.stringify(before.items.map(i=>[i.key,i.quantity])) !== JSON.stringify(check.body.items.map(i=>[i.key,i.quantity]));
              this.message(changed ? L('Kurven er ændret, men tilføjelsen kunne ikke bekræftes. Kontrollér kurven før et nyt forsøg.','Your cart has changed, but the item could not be confirmed. Check your cart before trying again.') : L('Tilføjelsen kunne ikke bekræftes. Kontrollér kurven før et nyt forsøg.','The item could not be confirmed. Check your cart before trying again.'),true,true);
            }
          } catch (_) { /* Keep the ambiguous state until a later cart read succeeds. */ }
        }
        if (!reconciled) this.message(posted ? L('Forbindelsen blev afbrudt. Kontrollér kurven, før du prøver igen.','The connection was interrupted. Check your cart before trying again.') : L('Kurven kunne ikke hentes. Prøv igen om et øjeblik.','The cart could not be loaded. Try again in a moment.'),true,posted);
      } finally {
        this.state.busy=false;
        this.current().update();
        this.group.pending--;
        if (!this.group.pending && this.group.nativeButtons) {
          const main=this.products.main.find(v=>String(v.id)===this.form.elements.namedItem('id')?.value);
          this.group.nativeButtons.forEach(({button,disabled})=>{button.disabled=disabled || !main?.available;});
          this.group.nativeButtons=null;
        }
        release();
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end',{bubbles:true}));
      }
    }
  }
  customElements.define('aashop-set-purchase',AASetPurchase);
})();
